<template>
  <div class="sheetRowDetails">
    <div class="box">
      <b-row>
        <b-col cols="6">poolinq-id</b-col>
        <b-col cols="6">{{ $t('general.bottleSize') }}</b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6">
          <span>{{ sheetRow.pqVenueWineId || '—' }}</span>
          <b-button v-if="hasVenueWineIdChanged" size="sm" variant="outline-success" class="revertMatchButton"
            :title="$t('receiptMatcher.revertMatchTitle')" @click="revertMatch">
            <b-icon icon="arrow-counterclockwise"></b-icon>
          </b-button>
        </b-col>
        <b-col cols="6">{{ sheetRow.bottleSize || '—' }}</b-col>
      </b-row>

      <b-row>
        <b-col class="smallText" cols="6">{{ $t('receiptMatcher.land') }}</b-col>
        <b-col class="smallText" cols="6">{{ $t('receiptMatcher.region') }}</b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6">{{ sheetRow.land || '—' }}</b-col>
        <b-col cols="6">{{ sheetRow.region || '—' }}</b-col>
      </b-row>

      <b-row>
        <b-col class="smallText" cols="6">{{ $t('receiptMatcher.wineType') }}</b-col>
        <b-col class="smallText" cols="6">{{ $t('general.grapeVariety') }}</b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6">{{ sheetRow.wineType || '—' }}</b-col>
        <b-col cols="6">{{ sheetRow.grapeVariety || '—' }}</b-col>
      </b-row>

      <b-row>
        <b-col class="smallText" cols="6">{{ $t('receiptMatcher.supplier') }}</b-col>
        <b-col class="smallText" cols="6">{{ sheetRow.isGlassWine ? $t('receiptMatcher.quantityGlasses') : $t('receiptMatcher.quantity') }}</b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6">{{ sheetRow.supplier || '—' }}</b-col>
        <b-col cols="6">{{ sheetRow.quantity || '—' }}</b-col>
      </b-row>

      <SheetRowSellingPrices v-if="sheetType === 'outbound'" :unitPrice="sheetRow.unitPrice"
        :totalPrice="sheetRow.totalPrice" :isGlassPrice="sheetRow.isGlassWine" :currency="getCurrency" />

      <SheetRowPurchasePrices v-if="sheetType === 'inbound'" :unitPrice="sheetRow.unitPrice"
        :totalPrice="sheetRow.totalPrice" :currency="getCurrency" />

      <div class="updaterStatusSection">
        <span class="smallText">{{ $t('receiptMatcher.updaterStatus') }}</span>
        <UpdaterStatusBadges :updaterStatus="sheetRow.updaterStatus" />
      </div>

      <SheetRowActionBar :show-save="hasVenueWineIdChanged" :show-import="canImportPosition"
        :show-ignore="canIgnorePosition" :show-create="canCreatePosition" @save="onSave" @import="onImport" @ignore="onIgnore" @create="onCreate" />

      <SheetRowIgnoreModal ref="ignoreModal" @confirmed="onIgnoreConfirmed" />
    </div>
  </div>
</template>

<script>
import SheetRowSellingPrices from './SheetRowSellingPrices.vue'
import SheetRowPurchasePrices from './SheetRowPurchasePrices.vue'
import UpdaterStatusBadges from './UpdaterStatusBadges.vue'
import SheetRowActionBar from './SheetRowActionBar.vue'
import SheetRowIgnoreModal from './SheetRowIgnoreModal.vue'
import { mapGetters } from 'vuex'
import * as Utils from '@/utils/functions'
import { sheetRowHasChangedVenueWineId, sheetRowHasEmptyUpdaterStatus, canImportSheetRow, canCreateProductFromSheetRow, canIgnoreSheetRow } from '@/utils/sheetRowFunctions'

export default {
  name: 'SheetRowDetails',
  components: {
    SheetRowSellingPrices,
    SheetRowPurchasePrices,
    UpdaterStatusBadges,
    SheetRowActionBar,
    SheetRowIgnoreModal,
  },
  props: {
    sheetRow: {
      type: Object,
      required: true,
    },
    sheetType: String, // inbound or outbound
  },
  computed: {
    ...mapGetters(['getVenue']),
    getCurrency() {
      return Utils.getVenueCurrency(this.getVenue)
    },
    hasVenueWineIdChanged() {
      return sheetRowHasChangedVenueWineId(this.sheetRow)
    },
    hasEmptyUpdaterStatus() {
      return sheetRowHasEmptyUpdaterStatus(this.sheetRow)
    },
    canImportPosition() {
      return canImportSheetRow(this.sheetRow)
    },
    canIgnorePosition() {
      return canIgnoreSheetRow(this.sheetRow)
    },
    canCreatePosition() {
      return canCreateProductFromSheetRow(this.sheetRow)
    },
  },
  methods: {
    revertMatch() {
      this.$emit('revert-match', this.sheetRow)
    },
    onSave() {
      this.$emit('save', this.sheetRow)
    },
    onImport() {
      this.$emit('import', this.sheetRow)
    },
    onIgnore() {
      this.$refs.ignoreModal.showModal()
    },
    onIgnoreConfirmed(addToBlacklist) {
      this.$emit('ignore', this.sheetRow, addToBlacklist)
    },
    onCreate() {
      this.$emit('create', this.sheetRow)
    },
  },
}
</script>

<style scoped>
.sheetRowDetails .box {
  padding: 10px;
}

.updaterStatusSection {
  margin-top: 16px;
}

.updaterStatusSection .smallText {
  display: block;
  margin-bottom: 6px;
}

.revertMatchButton {
  margin-left: 8px;
  padding: 0 6px;
  line-height: 1;
  vertical-align: middle;
}
</style>
